/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import { Input, FormGroup, Col, Label, Alert, Media, Row, Button } from 'reactstrap';
import Validator from '../../custom-classes/validator';
import Settings from '../../custom-classes/settings';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import SelectorPlan from "../selectors/selector-plan";
import ApiCalls from '../../custom-classes/api-calls';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBillAlt, faGraduationCap, faChalkboardTeacher} from '@fortawesome/free-solid-svg-icons';
import CheckBoxProductItems from '../selectors/multi-selector-product-items';
import CheckoutForm from '../stripe/stripe-card';
import {Elements, StripeProvider} from 'react-stripe-elements';
import ModalGeneric from '../modals/modal-generic';
import LoaderFullWindow from '../loader-windows/loader-full-window'

/**
 * The form to calculate the plan.It is used as the second step for the subscription
 */
class FormPlanCalculator extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state =
        {
            planId : null,
            subTokenStripe: null,
            validPlan: true,
            studentsQuantity: 1,
            studentsQuantityOptions: [],
            planDetails : null,
            itemsIncluded: [],
            hasItems: false,
            selectedItems: [],
            planCostDetails: null,
            planAvailableForIso: true,
            stripeApiKey: Settings.getStripeToken(),
            validCalculation: false,
            formCompleted: true,
            loading: false, // The loading modal
            propsModal: null, // Props modal of errors
            showErrorModal: false,
            userSubscribed: false
        }; // Default value

        this.setSelectedPlan = this.setSelectedPlan.bind(this);
        this.handleChangeSelectedPlanChange = this.handleChangeSelectedPlanChange.bind(this);
        this.setStripePaymentToken = this.setStripePaymentToken.bind(this);
        this.submitSubscription = this.submitSubscription.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
    }

    /**
     * Call the web services to create the subscription
     */
    submitSubscription()
    {
        if(this.state.planId === null
            || this.state.planId === "0"
            || this.state.validPlan === false
            || this.state.subTokenStripe === null
            || this.state.subTokenStripe.length === 0
            || this.state.selectedItems.length === 0
            || this.state.studentsQuantity === 0
        ) {
            this.setState({formCompleted: false});
        }
        else
        {
            this.setState({loading:true, formCompleted: true});
            let apiCalls = ApiCalls.createSubscriptions(this.state.planId,
                this.state.studentsQuantity,
                this.state.selectedItems,
                this.state.subTokenStripe);
            apiCalls.then((data)=> {
                if (!data.TransactionValid) {
                    let propsModal = {
                        bodyText: data.Messages[0],
                        visible: true
                    };
                    this.setState({propsModal: propsModal, showErrorModal: true, loading: false});
                }
                else {
                    this.setState({userSubscribed: true, loading: false, subscriptionId: data.Subscriptions[0].SubscriptionId});
                    this.props.updateParent(this.state);
                    return this.state;
                }
            });
        }
    }


    /**
     * Creates the selection for students quantity
     * @returns {XML}
     */
    renderQuantityOfStudentsSelection(){
        let arrOptions = [];
        for (let i = 1; i < 21; i++) {
            arrOptions.push(
                <option key={i} value={i}>
                    { String(i) }
                </option>
            );
        }
        return (
            <Input type="select" className="form-control" name="students-quantity" onChange={this.handleChangeSelectedPlanChange}>
                { arrOptions }
            </Input>
        );
    }

    /**
     * Action when the selection of quantity of student changes
     * @param e
     */
    handleChangeSelectedPlanChange(e) {
        this.setState({ studentsQuantity: e.target.value},()=>{
            this.calculateCosts();
        });
    }

    /**
     * Calculate the costs in the service
     */
    calculateCosts(){
        if(this.state.validPlan
            && this.state.studentsQuantity > 0
            && this.state.selectedItems.length > 0)
        {
            // Calculate cost
            let apiCall = ApiCalls.getPlanTotalCosts(this.state.planId, this.state.studentsQuantity);
            apiCall.then((data)=> {
                if(data.PlanCosts !== null)
                    this.setState({validCalculation: true});
                else
                    this.setState({validCalculation: false});

                this.setState({planCostDetails: this.renderTotals(data)});
            });
        }
    }

    /**
     * Sets the selected plan
     * @param field The field to add
     */
    setSelectedPlan = (field) => (newValue) => {

        // reset
        this.setState({
            planDetails: null,
            itemsIncluded: [],
            hasItems: false,
            selectedItems: [],
            planId: newValue,
            planAvailableForIso: true,
            }, ()=>{
                // If plan is not 0 and it's not null set the plan as valid
                this.setState({validPlan: (newValue !== "0" && newValue !== null)},()=>{
                    // This is promise
                    if(this.state.validPlan) {
                        let apiCall = ApiCalls.getCommercialPlanDetails(newValue);
                        apiCall.then((data)=> {
                            this.setState({
                                planDetails: this.renderPlanDetails(data),
                                itemsIncluded: data.Plans[0].ProductDetails.ItemsIncluded,
                                hasItems: data.Plans[0].ProductDetails.ItemsIncluded.length > 0,
                                planAvailableForIso: data.Plans[0].PlanAvailableForIso
                            });
                        },()=>{
                                this.calculateCosts();
                        });
                    }
                });
            });
    };

    /**
     * Render the total details
     * @param costData
     * @returns {*}
     */
    renderTotals(costData){
        if(costData.PlansCosts == null)
            return null;

        let taxesStr = '';
        for(let i=0; i < costData.PlansCosts.Taxes.length; i++)
        {
            taxesStr += costData.PlansCosts.Taxes[i].TaxName;
        }

        let intervalTranslate = "plan-calculator-form." + costData.PlansCosts.Interval;
        return(

            <Col sm={{ size: 10, offset: 1 }} md={{ size: 10, offset: 1 }} lg={{ size: 10, offset: 1 }} xs={{ size: 10, offset: 1 }}>
                <Label for="plan">
                    <b><Translate id="plan-calculator-form.total-cost" />{' ('}
                    <Translate id={intervalTranslate}/></b>{') '}
                </Label>
                <Row>
                    <Col sm={{ size: 8 }} md={{ size: 8 }} lg={{ size: 8 }} xs={{ size: 8 }}>
                            <Translate id="plan-calculator-form.subtotal"/>
                    </Col>
                    <Col sm={{ size: 4 }} md={{ size: 4 }} lg={{ size: 4 }} xs={{ size: 4 }}>
                        {costData.PlansCosts.SubTotal}
                    </Col>
                </Row>
                <Row>
                    <Col sm={{ size: 8 }} md={{ size: 8 }} lg={{ size: 8 }} xs={{ size: 8 }}>
                            <Translate id="plan-calculator-form.taxtotal"/> {' '}
                            <small>{taxesStr}</small>
                    </Col>
                    <Col sm={{ size: 4 }} md={{ size: 4 }} lg={{ size: 4 }} xs={{ size: 4 }}>
                        {costData.PlansCosts.TaxTotal}
                    </Col>
                </Row>
                <Row>
                    <Col sm={{ size: 8 }} md={{ size: 8 }} lg={{ size: 8 }} xs={{ size: 8 }}>
                        <Translate id="plan-calculator-form.total"/>
                        {' ('}
                        <Translate id={intervalTranslate}/> {') '}
                    </Col>
                    <Col sm={{ size: 4 }} md={{ size: 4 }} lg={{ size: 4 }} xs={{ size: 4 }}>
                       <b> {costData.PlansCosts.TotalCost}</b>
                    </Col>
                </Row>
            </Col>
        )
    }

    /**
     * Set the stripe payment token
     * @param field
     */
    setStripePaymentToken = (field) => (newValue) =>{

        if(newValue == null)
            this.setState({
                subTokenStripe: null
            });
        else
        {
            this.setState({
                subTokenStripe: newValue.id
            });
        }

    };

    /**
     * Set the selected classes in the state
     * @param field
     */
    setSelectedClasses = (field) => (newValue) =>{
        this.setState({
            selectedItems: newValue
        },()=>{
            this.calculateCosts();
        });
    };

    /**
     * Renders the plan details
     * @param data
     * @returns {*}
     */
    renderPlanDetails(data){
        // If null do not render anything
        if(data.Plans[0].PlanDescriptionByLang == null)
            return null;

        let planDescription = data.Plans[0].PlanDescriptionByLang[0].Description;
        let planPrice = data.Plans[0].ClientPrice;
        let translatePlanIntervalId = "plan-calculator-form." + data.Plans[0].Interval;
        let itemsIncludedTotal = data.Plans[0].ProductDetails.TotalItems;

        return(

             <Col sm={{ size: 10, offset: 1 }} md={{ size: 10, offset: 1 }} lg={{ size: 10, offset: 1 }} xs={{ size: 10, offset: 1 }}>
                 <p><FontAwesomeIcon icon={faGraduationCap} /> {' '} {planDescription}</p>
                 <p><FontAwesomeIcon icon={faMoneyBillAlt} /> {' '} <span className="blue-text">
                     {planPrice}</span>
                     {' '}
                     <Translate id="plan-calculator-form.per"/> {' '}
                     <Translate id={translatePlanIntervalId}/>
                 </p>
                 <p>
                     <FontAwesomeIcon icon={faChalkboardTeacher} /> {' '}
                     <Translate id="plan-calculator-form.quantity-classes-included"/>
                     {' '} {itemsIncludedTotal}</p>
             </Col>
            )
    };

    /**
     * Toogles alert modal
     */
    toggleAlertModal(){
        this.setState({showErrorModal: false});
    }

    // Render the form group
    render() {
        return (
            <div>
                <FormGroup row>
                    <Col sm={{ size: 10, offset: 1 }}>
                        <Label for="plan">
                            <b><Translate id="plan-calculator-form.plan" /></b>
                        </Label>
                        <SelectorPlan data={this.state.planId} value={this.state.planId} updateParent={this.setSelectedPlan("plan")}/>
                    </Col>
                </FormGroup>
                {!this.state.validPlan ?
                    <FormGroup row>
                        <Col sm={{ size: 10, offset: 1 }}>
                            <Alert color="danger" isOpen={!this.state.validPlan}>
                                <Translate id="plan-calculator-form.plan-error"/>
                            </Alert>
                        </Col>
                    </FormGroup> : null
                }

                <FormGroup row>
                    {this.state.planDetails !== null ? this.state.planDetails : null}
                </FormGroup>

                <FormGroup row>
                    <Col sm={{ size: 10, offset: 1 }}>
                        <Label for="plan">
                            <b><Translate id="plan-calculator-form.select-quantity-of-students" /></b>
                        </Label>
                        {this.renderQuantityOfStudentsSelection()}
                    </Col>
                    <Col sm={{ size: 10, offset: 1 }}>
                        <small> <Translate id="plan-calculator-form.need-more-than-20" /></small>
                    </Col>
                </FormGroup>
                {!this.state.studentsQuantity <= 0 ?
                    <FormGroup row>
                        <Col sm={{size: 10, offset: 1}}>
                            <Alert color="danger" isOpen={!this.state.validPlan}>
                                <Translate id="plan-calculator-form.quantity-students-error"/>
                            </Alert>
                        </Col>
                    </FormGroup> : null
                }

                {
                    this.state.hasItems ?
                        <FormGroup row>
                            <Col sm={{size: 10, offset: 1}}>
                            <Label for="plan">
                                <b><Translate id="plan-calculator-form.choose-classes" /></b>
                            </Label>
                                </Col>
                            <Col sm={{size: 10, offset: 1}}>
                        <CheckBoxProductItems data={this.state} updateParent={this.setSelectedClasses()} />
                            </Col>
                        </FormGroup>
                    : null
                }

                <FormGroup row>
                    {this.state.planCostDetails !== null ? this.state.planCostDetails : null}
                </FormGroup>

                {!this.state.planAvailableForIso ?
                    <FormGroup row>
                        <Col sm={{ size: 10, offset: 1 }}>
                            <Alert color="danger" isOpen={!this.state.planAvailableForIso}>
                                <Translate id="plan-calculator-form.plan-not-available-for-your-country"/>
                            </Alert>
                        </Col>
                    </FormGroup> : null
                }

                {
                    this.state.planAvailableForIso
                && this.state.validCalculation
                    ?
                        <FormGroup row>
                            <Col sm={{ size: 10, offset: 1 }}>
                                <StripeProvider apiKey={this.state.stripeApiKey}>
                                    <Elements>
                                        <CheckoutForm updateParent={this.setStripePaymentToken()} />
                                    </Elements>
                                </StripeProvider>
                            </Col>
                        </FormGroup>
                        : null
                }
                {
                    !this.state.formCompleted ?
                        <FormGroup row>
                            <Col sm={{ size: 10, offset: 1 }}>
                                <Alert color="danger" isOpen={!this.state.formCompleted}>
                                    <Translate id="plan-calculator-form.fill-fields"/>
                                </Alert>
                            </Col>
                        </FormGroup> : null
                }

                {
                    this.state.planAvailableForIso
                    &&
                    this.state.validCalculation
                    &&
                    this.state.subTokenStripe != null
                    &&
                    this.state.subTokenStripe.length > 0
                 ?
                <FormGroup row>
                    <Col sm={{ size: 10, offset: 1 }}>
                        <div color="success" className="btn btn-success btn-block" onClick={this.submitSubscription}>
                            <Translate id="general.submit" options={{renderInnerHtml: false}}/>
                        </div>
                    </Col>
                </FormGroup> : null
                }

                {this.state.loading ? <LoaderFullWindow/> : null}
                {this.state.showErrorModal ?
                    <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/> : null}
            </div>
        )
    };
}

export default FormPlanCalculator;


// WEBPACK FOOTER //
// ./src/components/forms/form-plan-calculator.js